const caseStudyBox = document.querySelector(".case-study-boxes");

/**
 * @description - Function checks if element is in the viewport and adds appropriate class to it.
 */
const showBoxesWhenInViewport = debounce(() => {
  if (caseStudyBox && isInViewport(caseStudyBox)) {
    caseStudyBox.classList.add("in-viewport");
  }
}, 30);

/**
 * Initialize functions on start and on scroll
 */
showBoxesWhenInViewport();

window.addEventListener("scroll", showBoxesWhenInViewport);
